import { hrmsUpload } from "../api/api";

/**
 * Upload an Excel file into an organization master-data table.
 * Preserves the org-table API contract:
 * POST /org_tables/upload/{tableName} with FormData field "file"
 * and X-Service-Code: HR20A.
 */
export async function uploadOrgTable(tableName, file) {
  const formData = new FormData();
  formData.append("file", file);

  return hrmsUpload(`/org_tables/upload/${tableName}`, formData, "HR20A");
}
